import { useMemo, useState } from "react";
import TableFilters from "./TableFilters";
import TableCellFormatter from "./TableCellFormatter";

export default function TableWrapper({ columnSchema = [], tableData = [], showFilters = false, isLoading = false }) {
  const [filters, setFilters] = useState({});

  const handleFilterChange = (id, value) => {
    setFilters((prev) => ({ ...prev, [id]: value }));
  };

  const filteredData = useMemo(() => {
    return tableData.filter((row) =>
      Object.entries(filters).every(([key, val]) => {
        if (!val) return true;
        const cell = row[key]?.toString().toLowerCase();
        return cell.includes(val.toString().toLowerCase());
      })
    );
  }, [tableData, filters]);

  return (
    <div className="space-y-2">
      {/* Filters Row */}
      {showFilters ? (
        <TableFilters columnSchema={columnSchema} filters={filters} onFilterChange={handleFilterChange} />
      ) : null}

      {/* Table */}
      <div className="overflow-x-auto rounded-lg relative">
        {isLoading && (
          <div className="fixed inset-0 bg-white/70 flex items-center justify-center z-50">
            <div className="w-8 h-8 border-4 border-gray-300 border-t-black rounded-full animate-spin" />
          </div>
        )}
        <table className="min-w-full bg-white border-separate border-spacing-0">
          <thead className="bg-gray-200 rounded-lg">
            <tr>
              {columnSchema.map((col) => (
                <th key={col.id} className="px-2.5 py-2 text-start text-xs font-bold text-gray-500">
                  {col.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredData?.map((row, rowIndex) => (
              <tr key={row.id || rowIndex} className="border-b border-gray-300 bg-gray-50">
                {columnSchema.map((col) => (
                  <td key={col.id} className={`px-3 py-2.5 text-sm text-start text-black${col.truncate ? " max-w-xs" : ""}`} style={col.truncate ? { maxWidth: "200px" } : {}}>
                    <TableCellFormatter type={col.type} value={row[col.id]} options={{ ...col.config, truncate: col.truncate }} />
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
